import { Controller } from "@hotwired/stimulus"

// Makes a textarea grow with its content (like a normal chat input) while never shrinking below
// its CSS min-height (which matches the send button). Runs on connect (so a re-rendered/empty
// box still sizes correctly) and on every input.
export default class extends Controller {
  connect() {
    this.resize()
  }

  resize() {
    this.element.style.height = "auto"
    this.element.style.height = `${this.element.scrollHeight}px`
  }
}
